import 'reflect-metadata';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'tippy.js/dist/border.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router';
import ThemeWrapper from './themes/ThemeWrapper';
import App from './App';
import { bootstrap } from './configuration';
import { ServiceProvider } from '@aesop-fables/containr-react';

const container = bootstrap();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ServiceProvider rootContainer={container}>
        <ThemeWrapper>
          <App />
        </ThemeWrapper>
      </ServiceProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
